import { Modal, Button } from "react-bootstrap";
import { FaSync } from "react-icons/fa";

const SUBTYPE_LABELS = {
    alta_nuevo: "Alta nueva",
    cambio_comercializador: "Cambio de comercializador",
    cambio_comerc_titular: "Cambio de comercializador y titular",
    cambio_comercializador_potencia: "Cambio de comercializador y potencia",
    cambio_comerc_titular_potencia: "Cambio comercializador, titular y potencia",
    cambio_comercializador_autoconsumo: "Cambio de comercializador y autoconsumo",
    cambio_comerc_titular_autoconsumo: "Cambio comercializador, titular y autoconsumo",
    cambio_comerc_potencia_autoconsumo: "Cambio comercializador, potencia y autoconsumo",
    cambio_completo: "Cambio completo (comercializador, titular, potencia y autoconsumo)",
};

export default function ConfirmRelanzarModal({
    show,
    onHide,
    onConfirmChangar, // Callback when user wants to change subtype
    onConfirmMantener, // Callback when user wants to keep current subtype
    currentSubtype = "", // Current offer subtype to display
}) {
    const getSubtypeLabel = (subtypeCode) => {
        return SUBTYPE_LABELS[subtypeCode] || subtypeCode;
    };

    const handleChangar = () => {
        onConfirmChangar();
        onHide();
    };

    const handleMantener = async () => {
        await onConfirmMantener();
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered contentClassName="border-0 rounded-4 shadow-lg">
            <Modal.Header className="bg-white border-bottom-0" closeButton>
                <Modal.Title className="fw-bold text-primary d-flex align-items-center gap-2">
                    <FaSync /> Relanzar oferta
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-4">
                <p className="text-muted mb-3">
                    ¿Deseas cambiar el tipo de oferta?
                </p>
                {currentSubtype && (
                    <div className="alert alert-info" role="alert">
                        <small className="text-muted">
                            Tipo actual: <strong className="text-info">{getSubtypeLabel(currentSubtype)}</strong>
                        </small>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="bg-light border-top">
                <Button variant="secondary" onClick={handleMantener}>
                    Mantener tipo actual
                </Button>
                <Button variant="primary" onClick={handleChangar}>
                    Cambiar tipo
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
